<template>
  <div style="width: 100%; height: 90%">
    <div class="example-error inactive">
      <span class="message"></span>
    </div>
    <!-- <div class="columns">
            <div class="column">
                <label><input type="checkbox" id="allColumns"> allColumns = true</label>
                <label><input type="checkbox" id="columnKeys"> columnKeys = ['country', 'bronze']</label>
                <label><input type="checkbox" id="columnGroups"> columnGroups = true</label>
                <label><input type="checkbox" id="onlySelected"> onlySelected = true</label>
                <label><input type="checkbox" id="onlySelectedAllPages"> onlySelectedAllPages = true</label>
                <label><input type="checkbox" id="shouldRowBeSkipped"> shouldRowBeSkipped = only20YearOlds</label>
            </div>
            <div class="column" style="margin-left: 20px;">
                <label><input type="checkbox" id="skipFooters"> skipFooters = true</label>
                <label><input type="checkbox" id="skipGroups"> skipGroups = true</label>
                <label><input type="checkbox" id="skipHeader"> skipHeader = true</label>
                <label><input type="checkbox" id="skipPinnedTop"> skipPinnedTop = true</label>
                <label><input type="checkbox" id="skipPinnedBottom"> skipPinnedBottom = true</label>
            </div>
        </div> -->

    <ag-grid-vue
      style="width: 100%; height: 90%"
      class="ag-theme-alpine"
      id="myGrid"
      :gridOptions="gridOptions"
      @grid-ready="onGridReady"
      :headerHeight="48"
      :columnDefs="columnDefs"
      :defaultColDef="defaultColDef"
      :rowData="rowData"
    >
    </ag-grid-vue>
    <v-btn color="green darken-1" v-on:click="addItems()">Add Row</v-btn>
    <v-btn color="blue darken-1" @click="save">Save</v-btn>
    <v-btn v-on:click="onBtnExportDataAsCsv()">Export CSV</v-btn>
    <!-- <button v-on:click="onBtnExportDataAsExcel()">api.exportDataAsExcel(params)</button> -->
  </div>
</template>
<script>
import { AgGridVue } from "ag-grid-vue";
import axios from "axios";
export default {
  name: "train_master",
  data() {
    return {
      gridOptions: null,
      gridApi: null,
      columnApi: null,
      columnDefs: null,
      defaultColDef: null,
      rowData: null,
      editedRowIDs: new Set([]),
      editedRows: [],
    };
  },
  components: {
    AgGridVue,
  },
  beforeMount() {
    this.gridOptions = {};
    this.columnDefs = [
      {
        headerName: "Sl No.",
        valueGetter: "node.rowIndex + 1",
        sortable: true,
        editable: false,
        onCellClicked: this.onCellClicked,
      },
      {
        headerName: "train_no",
        field: "train_no",
        sortable: true,
        minWidth: 100,
        filter: "agTextColumnFilter",
        filterParams: {
          resetButton: true,
          debounceMs: 200,
        },
      },
      {
        headerName: "train_name",
        field: "train_name",
        sortable: true,
        minWidth: 150,
        filter: "agTextColumnFilter",
      },
      {
        headerName: "tr type",
        field: "train_type",
        minWidth: 100,
        filter: "agTextColumnFilter",
      },
      { headerName: "dep", field: "dep", sortable: true },
      {
        headerName: "org",
        field: "org",
        sortable: true,
        filter: "agTextColumnFilter",
      },
      {
        headerName: "dest",
        field: "dest",
        sortable: true,
        filter: "agTextColumnFilter",
      },
      { headerName: "arr", field: "arr", sortable: true },
      { headerName: "days_of_run", field: "days_of_run" },
      // {headerName: 'valid_from', field: 'valid_from'},
      // {headerName: 'valid_to', field: 'valid_to'},
      { headerName: "zone", field: "zone" },
      { headerName: "divn", field: "divn" },
      { headerName: "depot", field: "depot" },
      { headerName: "travel_time", field: "travel_time" },
      { headerName: "total_kms ", field: "total_kms " },
      { headerName: "avg_speed ", field: "avg_speed " },
      { headerName: "er ", field: "er " },
      { headerName: "tr", field: "tr" },
    ];

    this.rowData = [
      { make: "Toyota", model: "Celica", price: 35000 },
      { make: "Ford", model: "Mondeo", price: 32000 },
      { make: "Porsche", model: "Boxter", price: 72000 },
    ];
    this.defaultColDef = {
      flex: 1,
      minWidth: 88,
      editable: true,
      resizable: true,
      onCellValueChanged: this.onCellValueChanged,
    };
    this.getTrains();
    // this.getTrainsBetweenStns('PTF','JGDL')
  },
  mounted() {
    this.gridApi = this.gridOptions.api;
    this.gridColumnApi = this.gridOptions.columnApi;
  },
  methods: {
    onBtnExportDataAsCsv() {
      var params = getParams();
      if (validateSelection(params)) {
        return;
      }
      this.gridApi.exportDataAsCsv(params);
    },
    onBtnExportDataAsExcel() {
      var params = getParams();
      if (validateSelection(params)) {
        return;
      }
      this.gridApi.exportDataAsExcel(params);
    },
    getTrains(calcall) {
      this.rowData = [];
      axios.defaults.headers.common["Authorization"] =
        localStorage.getItem("jwtToken");
      axios
        .get(`${process.env.VUE_APP_API_URL}/timetable/`)
        .then((response) => {
          console.log(response);
          this.rowData = response.data;
        })
        .catch((e) => {
          console.log(e);
        });
    },
    getTrainsBetweenStns(from_stn, to_stn) {
      var p = {
        from_stn: from_stn,
        to_stn: to_stn,
      };
      axios.defaults.headers.common["Authorization"] =
        localStorage.getItem("jwtToken");
      axios
        .get(`${process.env.VUE_APP_API_URL}/timetable/trains_between_stns`, {
          params: p,
        })
        .then((response) => {
          console.log(response);
        })
        .catch((e) => {
          console.log(e);
        });
    },
    onCellValueChanged(params) {
      this.editedRowIDs.add(params.node.id);
    },
    addItems(addIndex) {
      var newItems = [
        {
          divn: this.$store.state.curUser.division,
          zone: this.$store.state.curUser.zone,
        },
      ];
      var selectedData = this.gridApi.getSelectedRows();
      // console.log(selectedData)
      var res = this.gridApi.applyTransaction({
        add: newItems,
        addIndex: addIndex,
      });
    },
    save() {
      if (this.editedRowIDs.size == 0) {
        return;
      }
      this.editedRowIDs.forEach((id) => {
        this.editedRows.push(this.gridApi.getRowNode(id).data);
      });
      var p = {
        edited_trains: this.editedRows,
      };
      axios.defaults.headers.common["Authorization"] =
        localStorage.getItem("jwtToken");

      axios
        .post(`${process.env.VUE_APP_API_URL}/timetable/`, p)
        .then((response) => {
          // clear the set post update call
          this.editedRowIDs.clear();
          this.editedRows = [];
        })
        .catch((e) => {
          console.log(e);
        });
      // call the api to update data
    },
    onGridReady(params) {},
    onCellClicked(params) {
      console.log(this.gridApi.getRowNode(params.node.id).data);
      this.$router.push({
        path: "/train_dtls",
        // path: '/trainsdtl',
        query: {
          train_no: this.gridApi.getRowNode(params.node.id).data["train_no"],
        },
      });
    },
  },
};
window.getBooleanValue = function getBooleanValue(checkboxSelector) {
  return document.querySelector(checkboxSelector).checked === true;
};

window.only20YearOlds = function only20YearOlds(params) {
  return params.node.data && params.node.data.age != 20;
};

window.getParams = function getParams() {
  // return {
  //   allColumns: getBooleanValue('#allColumns'),
  //   columnGroups: getBooleanValue('#columnGroups'),
  //   columnKeys: getBooleanValue('#columnKeys') && ['country', 'bronze'],
  //   onlySelected: getBooleanValue('#onlySelected'),
  //   onlySelectedAllPages: getBooleanValue('#onlySelectedAllPages'),
  //   shouldRowBeSkipped:
  //     getBooleanValue('#shouldRowBeSkipped') && only20YearOlds,
  //   skipFooters: getBooleanValue('#skipFooters'),
  //   skipGroups: getBooleanValue('#skipGroups'),
  //   skipHeader: getBooleanValue('#skipHeader'),
  //   skipPinnedTop: getBooleanValue('#skipPinnedTop'),
  //   skipPinnedBottom: getBooleanValue('#skipPinnedBottom'),
  // };
  return {
    allColumns: true,
    // columnGroups: getBooleanValue('#columnGroups'),
    // columnKeys: getBooleanValue('#columnKeys') && ['country', 'bronze'],
    // onlySelected: getBooleanValue('#onlySelected'),
    // onlySelectedAllPages: getBooleanValue('#onlySelectedAllPages'),
    // shouldRowBeSkipped:
    //   getBooleanValue('#shouldRowBeSkipped') && only20YearOlds,
    // skipFooters: getBooleanValue('#skipFooters'),
    // skipGroups: getBooleanValue('#skipGroups'),
    // skipHeader: getBooleanValue('#skipHeader'),
    // skipPinnedTop: getBooleanValue('#skipPinnedTop'),
    // skipPinnedBottom: getBooleanValue('#skipPinnedBottom'),
  };
};

window.validateSelection = function validateSelection(params) {
  var message = "";
  var errorDiv = document.querySelector(".example-error");
  var messageDiv = errorDiv.querySelector(".message");
  if (params.onlySelected || params.onlySelectedAllPages) {
    message += params.onlySelected ? "onlySelected" : "onlySelectedAllPages";
    message += " is checked, please selected a row.";
    if (!gridInstance.api.getSelectedNodes().length) {
      errorDiv.classList.remove("inactive");
      messageDiv.innerHTML = message;
      window.setTimeout(function () {
        errorDiv.classList.add("inactive");
        messageDiv.innerHTML = "";
      }, 2000);
      return true;
    }
  }
  return false;
};
</script>
<style lang="scss">
@import "../../node_modules/ag-grid-community/dist/styles/ag-grid.css";
@import "../../node_modules/ag-grid-community/dist/styles/ag-theme-alpine.css";
.ag-header-cell-label {
  text-overflow: clip;
  overflow: visible;
  white-space: normal;
}
</style>
